import { Layout, Showcase, Grid, GridItem, UseCase, Header } from "../../../../src/components";
import { FaCheck, FaTimes } from 'react-icons/fa';
import changelog from "../../../../src/data/changelog.json";
import data from "../../../../src/pages/wt/guidelines/(deprecated) contextual-help/data.json";
import * as React from 'react';
export default {
  Layout,
  Showcase,
  Grid,
  GridItem,
  UseCase,
  Header,
  FaCheck,
  FaTimes,
  changelog,
  data,
  React
};